import script from "./MainButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MainButton.vue?vue&type=script&setup=true&lang=js"

import "./MainButton.vue?vue&type=style&index=0&id=54a9fea3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54a9fea3"]])

export default __exports__